<template>
  <div class="menu-additional-services">
    <a-row :gutter="[20, 32]">
      <a-col :span="8" class="menu-child" v-for="menuChildItem in menuChildItems" :key="menuChildItem.key" @click="goToPage(menuChildItem)">
        <template v-if="menuChildItem.enable">
          <div class="menu-child-icon-container">
            <l8-icon :class="['menu-icon', `icon-${menuChildItem.icon}`]" :type="`icon-${menuChildItem.icon}`"></l8-icon>
          </div>
          <p class="menu-child-name">{{menuChildItem.title}}</p>
        </template>
      </a-col>
    </a-row>
  </div>
</template>
<script>
export default {
  props: {
    menuChildItems: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    goToPage (item) {
      const { url } = item

      try {
        /* eslint-disable no-new */
        new URL(url)
        window.open(url, 'blank')
      } catch (err) {
        window.__MICRO_ROOT__.router?.push(url)
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
